import qs from "qs";
import { Resource } from "./resource";

export interface ListActions<TSimple> {
  fetchList: (params?: any) => Promise<ListDto<TSimple>>;
  fetchListLimitOffset(
    limit: number,
    offset: number,
    params?: any,
  ): Promise<ListDto<TSimple>>;
  fetchListPage(
    page: number,
    perPage: number,
    params?: any,
  ): Promise<ListDto<TSimple>>;
}

export type ListResource<TSimple = any> = Resource<ListActions<TSimple>>;

export interface ListDto<T> {
  count: number;
  items: T[];
}

export function createListResource<TSimple = any>(
  apiUrl: string,
  dataTransform: (data: any) => TSimple = (data: any) => data,
): ListResource<TSimple> {
  return (client) => ({
    async fetchList(params?) {
      const resp = await client.get(apiUrl, {
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "brackets" }),
      });
      const { count, items } = resp.data;
      return {
        count: count,
        items: (items as any[]).map(dataTransform),
      };
    },

    async fetchListLimitOffset(limit, offset, params?) {
      const resp = await client.get(apiUrl, {
        params: {
          limit,
          offset,
          ...params,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "brackets" }),
      });
      const { count, items } = resp.data;
      return {
        count: count,
        items: (items as any[]).map(dataTransform),
      };
    },

    fetchListPage(page, perPage, params?) {
      return this.fetchListLimitOffset(perPage, perPage * page, params);
    },
  });
}
